import * as React from 'react'
import { ResultsCl, TableHeader } from "../../../components/results-table-cl"
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from "../../../components/app/reducer"
import { CCB } from '../../../openapi/ccb'
import { Link } from "react-router-dom"

const CCBResults: React.FC = () => {
    const headerData: TableHeader<CCB> = { curr: "Currency", name: "CCB Name", city: "CCB City", ctry: "CCB Country" }    
    const ccbs = useSelector((state: RootReducer) => state.ccbReducer.ccbs)
    const numberOfIssuers: number = ccbs ? ccbs.length : 0; // should be taken from the length of the result as there is less than 100 CCBs globally 
    const searchCriteria = useSelector((state: RootReducer) => state.ccbReducer.ccbSearchCriteria);

    useEffect(() => {
        document.title = "Search for Cash Corespondent Bank Results"
    }
    , []) // empty array to signalize this is to be done on render and unmount only

    return (
        <div>
             <>
             <Link to="/ccb">Back to Search Criteria</Link>
             </>            
            <p className="codelist-header">Search for Cash Correspondents Results</p>
            <div>
                <div>
                    Your query returned the	following results. For more details about a specific Cash Correspondent, please click on the code.
				</div>
            </div>
            <div>
                {numberOfIssuers === 1 ? <span> <span className="bold"> 1 </span> CCB found. </span>
                                       : <span> <span className="bold"> {numberOfIssuers} </span> CCBs found. </span>
                }            
            </div>
            <ResultsCl recordsOnPage={10} header={headerData} data={ccbs} searchCriteria={searchCriteria}
                urlCSV="/codelist/v1/ccb/export/csv"
                urlXML="/codelist/v1/ccb/export/xml"
                leadingColumnContent={(item: CCB) => (<Link to={`/ccb/${item.acctno}`}>{item.curr}</Link>)} />
        </div>
    )
}


export default CCBResults